import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero3 from '../../components/hero3/hero3';
import About3 from '../../components/about3/about3';
import ProjectSectionS3 from '../../components/ProjectSectionS3/ProjectSectionS3';
import ContactArea from '../../components/ContactArea';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

const HomePage3 = () => {
    return (
        <Fragment>
            <div className="dark-mode" id="Home">
                <Navbar hclass={'wpo-header-style-3'} topbarNone={'topbar-none'} />
                <Hero3 />
                <About3 />
                <ProjectSectionS3 />
                <ContactArea btnClass={'theme-btn-s3'} />
                <Footer ftClass={'wpo-site-footer-s2'} />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default HomePage3;